module.exports = __webpack_public_path__ + "img/coursedefaultimage.972ce907.png";